/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from 'react-intl';

export default defineMessages({
    cov: {
        id: 'quoteandbind.PPRLinedirectives.templates.Information.Coverages',
        defaultMessage: 'Coverages'
    },
    form:{
        id: 'quoteandbind.PPRLinedirectives.templates.Information.Endorsements',
        defaultMessage: 'Endorsements'
    },
    stoFacNamValue: {
        id: 'quoteandbind.PPRLinedirectives.templates.LocRiskCoverage.Storage Facility Name',
        defaultMessage: 'Storage Facility Name : '
    },
    stoFacLocValue: {
        id: 'quoteandbind.PPLProLinedirectives.templates.LocRiskCoverage.Storage Facility Location',
        defaultMessage: 'Storage Facility Location : '
    }

});